
<template>
  <div>
    <v-dialog
      v-model="task_note_list_popup"
      persistent
      internal-activator
      style="overflow:auto;"
      max-width="1150px"
      max-height="800px !important"
    >
      <v-card tile :loading="task_list_loading">
        <v-card-title class="pa-0">
          <v-row dense no-gutters>
            <v-col class>
              <v-card-title class="pa-0">
                <v-col cols="4" class="d-flex p-0"></v-col>
                <v-col cols="4">{{task_name}} - Note</v-col>
                <v-col cols="4">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ml-5 header_btn"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="add_update_task_note_modal=true;modal_note_id='';modal_task_note='';"
                        :disabled="selectedRows2.length > 0"
                      >
                        <v-icon size="28px">mdi-file-plus-outline</v-icon>
                        <span class="lable_class">Add</span>
                      </v-btn>
                    </template>
                    <span>Add</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="selectedRows2.length > 0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="ml-5 header_btn"
                        fab
                        x-small
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="deleteNotes"
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Document(s)</span>
                  </v-tooltip>
                </v-col>
              </v-card-title>
            </v-col>
            <v-col cols="1" class="mt-2" style="max-width: 4%">
              <v-icon size="30" class="m drag-icon">mdi-drag-variant</v-icon>
            </v-col>
            <v-col cols="1" class="mt-2" style="max-width: 5%">
              <v-btn
                fab
                color="error"
                x-small
                @click="closeNoteListPopup()"
                class="custom-close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text
          class="pa-1 mx-auto"
          style="
            overflow: auto !important;
            max-height: 600px !important;
            min-height: 584px !important;
          "
        >
          <v-data-table
            :headers="headers"
            class="elevation-1 rounded-0 my-transaction-table document-list"
            :items="task_items.data"
            dense
            item-key="doc_id"
            :server-items-length="task_items.total"
            :options.sync="pagination"
            mobile-breakpoint="50"
            :footer-props="{
              'items-per-page-options': pagination_settings.perPageList,
            }"
          >
            <template v-slot:item.checkbox="{ item }" class="td">
              <v-simple-checkbox v-model="item.selected" :ripple="false"></v-simple-checkbox>
            </template>
            <template v-slot:item.edit="{ item }" class="td">
              <v-icon
                class="mr-2"
                @click="add_update_task_note_modal=true;modal_note_id=item.note_id;modal_task_note=item.task_note;"
              >mdi-clipboard-edit-outline</v-icon>
            </template>

            <template
              v-slot:item.created_at="{ item }"
              class="td"
            >{{ displayDateTimeFormate(item.created_at, "date") }}</template>

            <template v-slot:item.task_note="{ item }" class="td">{{ item.task_note }}</template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="add_update_task_note_modal" persistent max-width="500px">
      <v-card :loading="update_task_loading">
        <v-card-title>
          <span class="headline">{{modal_note_id=='' ? 'Add' : 'Update'}} Task Note</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-textarea
              dense
              v-model="modal_task_note"
              outlined
              rows="3"
              :error-messages="form_error.task_note"
              :hide-details="!form_error.task_note"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="add_update_task_note_modal = false;">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :loading="update_task_loading" @click="UpdateTaskNote()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import { mapState, mapMutations, mapActions } from "vuex";
import { parseParams } from "../../plugins/helper";
const moment = require("moment");
export default {
  name: "TaskList",
  data: () => ({
    form_error: [],
    headers: [
      {
        value: "checkbox",
        text: "#",
        sortable: false,
        width: "2%",
        align: "center"
      },
      {
        value: "edit",
        text: "#",
        sortable: false,
        width: "2%",
        align: "center"
      },

      {
        value: "task_note",
        text: "Note",
        sortable: true,
        width: "75%",
        align: "center"
      },
      {
        value: "user.first_name",
        text: "User",
        sortable: false,
        width: "10%",
        align: "center"
      },

      {
        value: "created_at",
        text: "Date",
        sortable: false,
        width: "10%",
        align: "center"
      }

      // {
      //   value: "info",
      //   text: "Action",
      //   sortable: false,
      //   width: "10%",
      //   align: "center"
      // }
      // {
      //   value: "task_order",
      //   text: "Task Order",
      //   sortable: false,
      //   width: "15%",
      // },
      // { value: "user.first_name", text: "User", sortable: false, width: "15%" },
      // { value: "action", text: "View", sortable: false, width: "7.5%" },
    ],
    search: "",
    task_list_loading: false,
    task_items: [],
    add_update_task_note_modal: false,
    update_task_loading: false,
    modal_note_id: "",
    modal_task_note: "",
    filter_menu: false,
    pagination: {
      itemsPerPage: 20,
      sortBy: ["note_id"],
      page: 1,
      search: "",
      filters: {
        status: "all"
      }
    },
    status_list: []
  }),
  props: ["task_note_list_popup", "unique_id", "o_id", "task_name"],
  watch: {
    task_note_list_popup: {
      handler(val) {
        if (val) {
          this.pagination.filters.status = "";

          this.getTaskNoteList(parseParams(this.pageData));
        }
      }
    },
    pagination: {
      handler() {
        this.getTaskNoteList(parseParams(this.pageData));
      },
      deep: true
    }
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),

    pageData() {
      let paginationData = this.pagination;
      return paginationData;
    },
    selectedRows2() {
      let returnData = [];
      if (this.task_items.data) {
        this.task_items.data.filter(function(item) {
          if (item.selected) {
            returnData.push(item);
          }
        });
      }
      return returnData;
    }
  },

  methods: {
    ...mapActions("task", ["getTasks", "getTotalTaskDays"]),
    ...mapMutations("addtask", ["setAddTaskData"]),
    ...mapMutations("document", ["setDocumentData"]),

    displayDateTimeFormate(date, flag) {
      if (flag == "time") {
        return moment(date).format("H:mm:ss");
      } else if (flag == "datetime") {
        return moment(date).format("MM/DD/YYYY H:mm");
      } else {
        return moment(date).format("MM/DD/YYYY");
      }
    },
    closeNoteListPopup() {
      this.$emit("closeTaskNoteListPopup");
    },
    deleteNotes() {
      let _self = this;
      let ids = [];
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      this.selectedRows2.map(function(item) {
        ids.push(item.note_id);
      });
      if (ids.length > 0) {
        axios
          .post("calendar_task/delete_note", {
            ids: ids,
            company_id: company_data.company_id
          })
          .then(function() {
            _self.getTaskNoteList(parseParams(_self.pageData));
          })
          .catch(function() {
            console.log("FAILURE!!");
          });
      }
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
        // console.log('cancel request done');
      }
    },
    getTaskNoteList(url) {
      let _self = this;
      var unique_id = _self.unique_id;
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();
      axios
        .get(
          "calendar_task/get_task_note_list?unique_id=" + unique_id + "&" + url,
          { cancelToken: this.cancelSource.token }
        )
        .then(function(res) {
          if (res.data.status) {
            let data = res.data;
            _self.task_items = data.data;
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },

    addCalendarTaskModal(c_task_id, unique_id) {
      this.setAddTaskData({ key: "p_id", value: this.o_id });
      this.setAddTaskData({ key: "type_module", value: 8 });
      this.setAddTaskData({ key: "c_task_id", value: c_task_id });
      this.setAddTaskData({ key: "unique_id", value: unique_id });
      this.setAddTaskData({ key: "add_calendar_task_modal", value: true });
    },
    UpdateTaskNote() {
      let _self = this;
      axios
        .post("calendar_task/update_task_note_list", {
          note_id: _self.modal_note_id,
          task_id: _self.unique_id,
          task_note: _self.modal_task_note,
          user_id: localStorage.getItem("user_id")
        })
        .then(function(res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.$set(_self.form_error, key, data.errors[key][0]);
            }
          } else {
            _self.getTaskNoteList(parseParams(_self.pageData));
            _self.update_task_loading = false;
            _self.add_update_task_note_modal = false;
          }
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    }
  }
};
</script>

<style scoped>
.theme--dark.v-tabs > .v-tabs-bar {
  background-color: #1e1e1e7a !important;
}
.header_btn {
  color: #757575 !important;
}
</style>